var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyViolateYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.35973 23.4817C12.1288 23.4817 14.3736 21.288 14.3736 18.5818C14.3736 15.8757 12.1288 13.6819 9.35973 13.6819C6.59064 13.6819 4.34586 15.8757 4.34586 18.5818C4.34586 21.288 6.59064 23.4817 9.35973 23.4817Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.35968 24.9807C2.62077 24.9807 0 29.4714 0 31.5599C0 33.6483 5.57963 34.2045 9.35968 34.2045C13.1397 34.2045 18.7194 33.6483 18.7194 31.5599C18.7194 29.4714 16.0986 24.9807 9.35968 24.9807Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.5 9.97266C20.7522 9.97266 20.1462 10.5649 20.1462 11.2956C20.1462 12.0264 20.7522 12.6186 21.5 12.6186C22.2477 12.6186 22.8537 12.0264 22.8537 11.2956C22.8537 10.5649 22.2477 9.97266 21.5 9.97266Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.5 8.5265C20.9821 8.5265 20.5625 8.11641 20.5625 7.61031V2.04022C20.5625 1.53411 20.9821 1.12402 21.5 1.12402C22.0179 1.12402 22.4375 1.53411 22.4375 2.04022V7.61031C22.4375 8.11641 22.0179 8.5265 21.5 8.5265Z",
    fill: "#FFCD00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyViolateYellow);
export default __webpack_public_path__ + "static/media/daily_violate_yellow.7e17695be10c8c4e03c3f5e6a18b2da6.svg";
export { ForwardRef as ReactComponent };